import React from "react";
import AuthForm from "./AuthForm";
import AuthSocial from "./AuthSocial";
import { useRouter } from "utilities/router";
import { useToast } from "components/Toast";

function Auth(props) {
  const router = useRouter();
  const { toast } = useToast();

  const handleAuth = (user) => {
    router.navigate(props.afterAuthPath);
  };

  return (
    <>
      <AuthForm
        type={props.type}
        buttonAction={props.buttonAction}
        onAuth={handleAuth}
        inviteEmail={props.inviteEmail}
        onExistingAccount={props.onExistingAccount}
      />
      {["signin"].includes(props.type) && (
        <>
          {props.providers && props.providers.length && (
            <AuthSocial
              buttonAction={props.buttonAction}
              providers={props.providers}
              showLastUsed={true}
              onAuth={handleAuth}
              onError={(message) => {
                toast({
                  status: "destructive",
                  title: message,
                });
              }}
            />
          )}
        </>
      )}
    </>
  );
}

export default Auth;
